
export const VIEW_DISPLAYED = 'VIEW_DISPLAYED';
